module.exports = __webpack_public_path__ + "fonts/fa-brands-400.0d215870.woff";